import { API_AUTH } from "./common";

const MenuApi = {
  getMenu: () => API_AUTH.get(`menu/get-menu`, {}),
  getMenu1: () => API_AUTH.get(`menu/get-menu1`, {}),
  getBadgeMenu: () => API_AUTH.get(`menu/get-badge-menu`, {}),
};

export default MenuApi;
